module.exports = __webpack_public_path__ + "static/theme-editor-payment-icons-049a61f485115c31e9d47fba6dbad575.png";